import { useMemo } from 'react';
import Slider from 'react-slick';
import { MultiRequisitesType } from '@shared/api';
import './multiRequisites.scss';

interface MultiRequisitesProps {
  requisites: MultiRequisitesType[];
  onSlideChange: (value: number) => void;
}

export const MultiRequisites = (props: MultiRequisitesProps) => {
  const settings = useMemo(
    () => ({
      dots: props.requisites?.length > 1,
      arrows: props.requisites?.length > 1,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      swipe: props.requisites?.length > 1,
      draggable: props.requisites?.length > 1,
      fade: props.requisites?.length === 1,
    }),
    [props.requisites],
  );

  return (
    <Slider {...settings} className='slider-multi_requisites' beforeChange={(_, nextSlide) => props.onSlideChange(nextSlide)}>
      {props.requisites?.map((item, idx) => (
        <div key={idx} className='pt-5'>
          <div className='mx-auto flex border-collapse items-center justify-center'>
            <div className='relative table-cell h-[18px] overflow-hidden text-center text-base font-semibold whitespace-nowrap text-[#b18c62] uppercase'>
              Bank Details {idx + 1}
            </div>
          </div>
          <div className='-mx-5 mt-5 w-[calc(100%+44px)] rounded bg-[#262727] pt-0.5 shadow-[inset_0_1px_0_0_#0000004a]'>
            <div className='overflow-hidden'>
              <div className='w-full table-fixed border-collapse translate-x-0 transition-transform duration-300'>
                <div className='table-cell align-top'>
                  <div className='px-11'>
                    <div className='mt-4 flex flex-col gap-3'>
                      <div>
                        <div className='text-xs font-semibold text-[#929292] uppercase'>Beneficiary Name</div>
                        <div className='text-sm font-semibold text-[#fcfcfc] uppercase'>{item.OwnerName}</div>
                      </div>
                      <div>
                        <div className='text-xs font-semibold text-[#929292] uppercase'>Beneficiary Address</div>
                        <div className='text-sm font-semibold text-[#fcfcfc] uppercase'>{item.BeneficiaryAddress}</div>
                      </div>
                      <div>
                        <div className='text-xs font-semibold text-[#929292] uppercase'>Iban / Account Number</div>
                        <div className='text-sm font-semibold text-[#fcfcfc] uppercase'>{item.IBAN}</div>
                      </div>
                      <div>
                        <div className='text-xs font-semibold text-[#929292] uppercase'>BIC / SWIFT</div>
                        <div className='text-sm font-semibold text-[#fcfcfc] uppercase'>{item.BIC}</div>
                      </div>
                      <div>
                        <div className='text-xs font-semibold text-[#929292] uppercase'>Bank</div>
                        <div className='text-sm font-semibold text-[#fcfcfc] uppercase'>{item.BankName}</div>
                      </div>
                      <div>
                        <div className='text-xs font-semibold text-[#929292] uppercase'>Bank Address</div>
                        <div className='text-sm font-semibold text-[#fcfcfc] uppercase'>{item.BankAddress}</div>
                      </div>
                      <p className='mb-4 text-xs font-semibold text-[#fcfcfc] uppercase'>
                        <mark className='bg-transparent p-0 text-[#a73f33]'>NOTE:</mark> Please indicate your
                        <mark className='bg-transparent p-0 text-[#a73f33]'> {item.Name} </mark>
                        as payment reference
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};
